import { render } from "./BusinessCardPreview.vue?vue&type=template&id=63468ed3&scoped=true"
import script from "./BusinessCardPreview.vue?vue&type=script&lang=js"
export * from "./BusinessCardPreview.vue?vue&type=script&lang=js"

import "./BusinessCardPreview.vue?vue&type=style&index=0&id=63468ed3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63468ed3"]])

export default __exports__